<template>
  <div class="item">
      <div class="tit" :style="{color:color}">{{label}}</div>
      <slot />
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            label: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: ''
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
  .item {
    padding-left: 16px;
    padding-right: 16px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tit{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
    }

  }
</style>
